module.exports = __webpack_public_path__ + "img/about_csv_template_03.d5a8ff58.png";